package com.kinoshazam.uiKit.components.expandableDescription

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.Medium
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.details_less
import kinoshazam.resources.generated.resources.details_more
import org.jetbrains.compose.resources.stringResource

private const val CollapsedMaxLines = 3

@Composable
fun ExpandableDescription(
    text: String,
    expanded: Boolean,
    onToggle: () -> Unit,
    modifier: Modifier = Modifier,
) {
    var canExpand by remember(text) { mutableStateOf(false) }
    val toggleInteraction = remember { MutableInteractionSource() }
    val isToggleHovered by toggleInteraction.collectIsHoveredAsState()

    Column(modifier = modifier) {
        Text(
            text = text,
            style = Medium,
            color = UiKitTheme.colors.color_2,
            maxLines = if (expanded) Int.MAX_VALUE else CollapsedMaxLines,
            overflow = TextOverflow.Ellipsis,
            onTextLayout = { layoutResult ->
                if (!expanded) {
                    canExpand = layoutResult.hasVisualOverflow
                }
            },
            modifier = Modifier
                .padding(horizontal = 16.dp)
                .then(
                    if (canExpand) Modifier.clickable(onClick = onToggle) else Modifier
                ),
        )

        if (canExpand) {
            Spacer(modifier = Modifier.height(12.dp))
            Text(
                text = stringResource(
                    if (expanded) Res.string.details_less else Res.string.details_more
                ),
                style = BoldMedium,
                color = if (isToggleHovered) UiKitTheme.colors.color_22 else UiKitTheme.colors.color_1,
                modifier = Modifier
                    .padding(horizontal = 16.dp)
                    .clickable(
                        interactionSource = toggleInteraction,
                        indication = null,
                        onClick = onToggle,
                    ),
            )
        }
    }
}
